export const testimonials = [
  {
    quote:
      "Our business became much easier to find online, and customers appreciated the updated information.",
    author: "Local Retail Owner",
  },
  {
    quote:
      "The website gave our shop a professional image and made it easy for customers to contact us.",
    author: "Shop Owner",
  },
  {
    quote:
      "The product catalog helped us showcase our inventory without needing a full e-commerce store.",
    author: "Wholesale Trader",
  },
];
